export default __webpack_public_path__ + "static/media/paymentgateway.7604c18d.svg";